import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetStructure,
    SaveStructure
};

function GetStructure(contractId, versionId, editionId, onSuccess, onError){

    var headers = getAuthHeader();
    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/structure`, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            console.log(error)
            onError(error);
        });
}

function SaveStructure(contractId, versionId, editionId, structure, onSuccess, onError){

    var headers = getAuthHeader();
    
    axios
        .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/structure`, structure, headers)
        .then(response => {
            onSuccess(response.data); 
        })
        .catch(error => {
            onError(error);
        });
}
